import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { useDispatch } from 'react-redux';
import { setOnlineUser } from '../features/user/userSlice';
import { getLocalStorageData } from '../shared/commonFunction';

const useSocket = () => {
    const socketRef = useRef();
    const [isReady, setIsReady] = useState(false);
    // const BASE_URL = "http://localhost:3000";
    // const BASE_URL = 'wss://fapi.fanzaty.net';

    const BASE_URL = import.meta.env.VITE_CHAT_BASE_URL;
    const dispatch = useDispatch();

    useEffect(() => {
        const token = getLocalStorageData('token');

        const socket = io(BASE_URL, {
            transports: ['websocket'],
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
            auth: { token },
            path: '/api/socket.io',
        });

        socket.on('connect', () => {
            console.log('Connected:', socket.id);
            setIsReady(true);
        });

        socket.on('disconnect', (reason) => {
            console.log('Disconnected:', reason);
            setIsReady(false);
        });

        socket.on('connect_error', (error) => {
            console.error('Connection Error:', error);
            setIsReady(false);
        });

        socket.on('onlineUser', (data) => {
            dispatch(setOnlineUser(data));
        });

        socketRef.current = socket;

        return () => {
            socket.disconnect();
        };
    }, [BASE_URL, dispatch]);

    return { socket: socketRef.current, isReady };
};

export default useSocket;
